module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("Copyright © 1966 by Austryn Wainhouse and Richard Seaver")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("“Must We Burn Sade?” by Simone de Beauvoir copyright © 1955 by "), _c('em', [_vm._v("Editions Gallimard,")]), _vm._v(" Paris, France; translation copyright © 1953 by Grove Press, New York. “Nature as Destructive Principle,” by Pierre Klossowski copyright © 1964 by "), _c('em', [_vm._v("Au Cercle du Livre Précieux,")]), _vm._v(" translation copyright © 1965 by Yale French Studies.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, of the facilitation thereof, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Published simultaneously in Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('em', [_vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Sade, marquis de, 1740–1814.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighti"
  }, [_vm._v("The 120 days of Sodom and other writings.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightia"
  }, [_vm._v("Bibliography: p.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighti"
  }, [_vm._v("Includes index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighti"
  }, [_vm._v("1. Sade, marquis, de, 1740–1814—Translations, English. 2. Erotic literature, French—Translations into English. 3. Erotic literature, English—Translations from French. I. Wainhouse, Austryn. II. Seaver, Richard. III. Title. IV. Title: One hundred twenty days of Sodom and other writings. V. Title: Marquis de Sade.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("PQ2063.S3A28     1987       843’.6                            87-7394")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("ISBN-10: 0-8021-3012-7")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("ISBN-13: 978-0-8021-3012-9")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Grove Press")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("an imprint of Grove/Atlantic, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("841 Broadway")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("New York, NY 10003")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.groveatlantic.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("08 09 10 25 24 23 22 21 20")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 72
// module chunks = 0